import { dt } from '@primeuix/themes';

export const inputSwitchTheme = {
  css: ({ dt: any }: any): string => `
  .p-toggleswitch-checked.p-disabled .p-toggleswitch-slider {
    background: ${dt('sd.secondary.disabled')};
  }
  `,
  root: {
    width: '{size.pixel.40}',
    height: '{size.pixel.24}',
    borderWidth: '1px',
    transitionDuration: '{transition.duration}',
    slideDuration: '200ms'
  },
  handle: {
    size: '{size.pixel.16}'
  },
  colorScheme: {
    light: {
      root: {
        background: '{surface.400}',
        disabledBackground: '{surface.300}',
        borderColor: '{surface.400}',
        checkedBackground: '{sd.secondary.color}',
        checkedBorderColor: '{sd.secondary.color}'
      },
      handle: {
        background: '{surface.50}',
        disabledBackground: '{surface.50}',
        checkedBackground: '{surface.50}'
      }
    }
  }
};
